import React from 'react';
import { Link } from 'react-router-dom';
import './FeaturedHero.css';
import featuredImage from '../prvi-trimestar-image.png';

const FeaturedHero = () => {
  return (
    <section className="featured-hero-section">
      <Link to="/post/683711ce48879b30ea23a035" className="featured-hero-link">
        <div className="featured-hero-container">
          <div className="featured-hero-content">
            <div className="category-tag">
              Trudnoća
            </div>
            <h2 className="featured-hero-title">
              Prvi trimestar: šta očekivati i kako se pripremiti?
            </h2>
            <p className="featured-hero-description">
              Krenite na uzbudljivo putovanje prvog tromesečja sa samopouzdanjem. 
              Od jutarnjih lekova za mučninu do osnovnih saveta za prenatalnu negu.
            </p>
            <div className="featured-hero-meta">
              <div className="meta-item">
                <svg className="calendar-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <span>15. decembar 2024</span>
              </div>
              <div className="meta-item">
                <svg className="clock-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>8min read</span>
              </div>
            </div>
          </div>
          <div className="featured-hero-image">
            <img 
              src={featuredImage} 
              alt="Prvi trimestar: šta očekivati i kako se pripremiti" 
              className="featured-img"
            />
          </div>
        </div>
      </Link>
    </section>
  );
};

export default FeaturedHero; 